export default "__VITE_ASSET__11c27bb1__"